import { createFileRoute } from '@tanstack/react-router';
import { UsernameSelectionScreen } from '../../features/auth/username-selection-screen';

export const Route = createFileRoute('/_auth/username')({
  component: UsernameSelectionScreen,
});
